<div class="form-group">
  <div class="form-group-label">
    <ng-content select="tpl-form-label"></ng-content>
  </div>

  <div class="form-group-container">
    <ng-content></ng-content>
  </div>
</div>
